const permissionName = {
  HOME: "home",
  PAYMENT: "payment",
  PAYMENT_SO: "payment-so",
  REVISION_PRICE: "revision-price",
  COUNTRY: "country",
  COUNTRY_RESTRICTION: "country-restriction",
  CUSTOMER_MANAGEMENT: "customer-management",
  CUSTOMER_MANAGEMENT_PAYMENT_LOG: "customer-management-payment-log",
  CUSTOMER_MANAGEMENT_GATEWAY_MANAGEMENT:
    "customer-management-gateway-management",
  SALE_BINDING_REQUEST_MANAGEMENT: "sale-binding-request-management",
  CUSTOMER_MANAGEMENT_SENDER: "customer-management-sender",
  CUSTOMER_MANAGEMENT_BLACKLIST: "customer-management-blacklist",
  CUSTOMER_MANAGEMENT_FOBIDDEN_COUNTRY: "customer-management-fobidden-country",
  CUSTOMER_MANAGEMENT_SPECIAL_PRICE: "customer-management-special-price",
  OFFER_MANAGEMENT: "offer-management",
  PRICE_MANAGEMENT: "price-management",
  GATEWAY_MANAGEMENT: "gateway-management",
  SENDER_POOL: "sender-pool",
  SENDER_DEFAULT: "sender-default",
  SENDER_GENERIC: "sender-generic",
  SMS_LOG: "sms-log",
  BLACKLIST_MANAGEMENT: "blacklist-management",
  KEYWORD: "keyword",
  ADMIN_MANAGEMENT: "admin-management",
  CUSTOMER_MANAGEMENT_SALE_OWNER: "customer-management-so",
};

const permissionType = {
  READ: "read",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  APPROVE: "approve",
  REJECT: "reject",
  SEND_EMAIL: "send_email",
  STEALTH_LOGIN: "stealth-login",
  ADD_CREDIT: "add_credit",
  ALLOW_ALL: "allow_all",
  RELOAD: "reload",
  SET_DEFAULT: "set_default",
  READ_MARKET_RATE: "read-market-rate",
  READ_GATEWAY_RATE: "read-gateway-rate",
  READ_NOTIFY_USER: "read-notify-user",
};

export { permissionName, permissionType };



// WEBPACK FOOTER //
// ./src/config/permission.js